<template>
  <div class="main">
    <router-view></router-view>
    <tab-bar>
      <tab-bar-item path="/home" activeColor="#9b1f24" activeBgColor="rgba(255, 223, 137, 0.8)">
        <img slot="item-icon" src="~assets/img/tabbar/tabbar1.png" alt="" />
        <img
          slot="item-icon-active"
          src="~assets/img/tabbar/tabbar1_2.png"
          alt=""
        />
        <div slot="item-text">首页</div>
      </tab-bar-item>
      <tab-bar-item path="/profiles" activeColor="#9b1f24" activeBgColor="rgba(255, 223, 137, 0.8)">
        <img slot="item-icon" src="~assets/img/tabbar/tabbar2.png" alt="" />
        <img
          slot="item-icon-active"
          src="~assets/img/tabbar/tabbar2_2.png"
          alt=""
        />
        <div slot="item-text">简介</div>
      </tab-bar-item>
      <tab-bar-item path="/vr" activeColor="#9b1f24" activeBgColor="rgba(255, 223, 137, 0.8)">
        <img slot="item-icon" src="~assets/img/tabbar/tabbar3.png" alt="" />
        <img
          slot="item-icon-active"
          src="~assets/img/tabbar/tabbar3_2.png"
          alt=""
        />
        <div slot="item-text">线上观景</div>
      </tab-bar-item>
      <tab-bar-item path="/culture" activeColor="#9b1f24" activeBgColor="rgba(255, 223, 137, 0.8)">
        <img slot="item-icon" src="~assets/img/tabbar/tabbar4.png" alt="" />
        <img
          slot="item-icon-active"
          src="~assets/img/tabbar/tabbar4_2.png"
          alt=""
        />
        <div slot="item-text">汉牡丹文化</div>
      </tab-bar-item>
      <tab-bar-item path="/appreciate" activeColor="#9b1f24" activeBgColor="rgba(255, 223, 137, 0.8)">
        <img slot="item-icon" src="~assets/img/tabbar/tabbar4.png" alt="" />
        <img
          slot="item-icon-active"
          src="~assets/img/tabbar/tabbar4_2.png"
          alt=""
        />
        <div slot="item-text">花卉欣赏</div>
      </tab-bar-item>
    </tab-bar>
  </div>
</template>

<script>
import TabBar from "./tabbar/TabBar.vue";
import TabBarItem from "./tabbar/TabBarItem.vue";

export default {
  name: "MainTabBar",
  components: {
    TabBar,
    TabBarItem,
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
}
</style>